// extracted by mini-css-extract-plugin
export var details = "_l6-0";
export var inspectorPopover = "_l6-1";